import { makeStyles } from '@material-ui/core'
import React, { MouseEvent, useState } from 'react'
import { NavLink } from 'react-router-dom'

export interface OrganizationLayoutLinkProps {
  text: string
  subText: string
  to: string
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void
  imageUrl: string
  hoverImageUrl: string
}

const useStyles = makeStyles((theme) => {
  return {
    menuLink: {
      padding: '14px 22px 12px',
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      color: theme.palette.neutrals[500],
      transition: 'color 0.3s ease',

      '&:hover, &.active': {
        backgroundColor: theme.palette.primary[50],
        color: theme.palette.primary[600],
      },

      '& [data-name="image"]': {
        display: 'block',
      },
      '& [data-name="hover-image"]': {
        display: 'none',
      },
      '&:hover [data-name="image"]': {
        display: 'none',
      },
      '&:hover [data-name="hover-image"]': {
        display: 'block',
      },
      '&.active [data-name="image"]': {
        display: 'none',
      },
      '&.active [data-name="hover-image"]': {
        display: 'block',
      },
      '&:hover.active [data-name="image"]': {
        display: 'none',
      },
      '&:hover.active [data-name="hover-image"]': {
        display: 'block',
      },
    },
    menuIcon: {
      width: '32px',
      height: '32px',
      minWidth: '32px',
      stroke: 'currentColor',
    },
    menuLinkTexts: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    },
    menuLinkText: {
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '16px',
      color: 'currentcolor',
    },
    menuLinkSubtext: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '14px',
      color: 'currentcolor',
    },
  }
})

const OrganizationLayoutLink: React.FC<OrganizationLayoutLinkProps> = ({
  text,
  subText,
  to,
  onClick,
  imageUrl,
  hoverImageUrl,
}) => {
  const classes = useStyles()

  return (
    <NavLink to={to} className={classes.menuLink} activeClassName='active' onClick={onClick}>
      <div className={classes.menuIcon}>
        <img data-name='image' src={imageUrl} alt={text} />
        <img data-name='hover-image' src={hoverImageUrl} alt={text} />
      </div>
      <div className={classes.menuLinkTexts}>
        <p className={classes.menuLinkText}>{text}</p>
        <p className={classes.menuLinkSubtext}>{subText}</p>
      </div>
    </NavLink>
  )
}

export default OrganizationLayoutLink
